import { render, staticRenderFns } from "./tagInput.vue?vue&type=template&id=2ac5956c&scoped=true&"
import script from "./tagInput.vue?vue&type=script&lang=js&"
export * from "./tagInput.vue?vue&type=script&lang=js&"
import style0 from "./tagInput.vue?vue&type=style&index=0&id=2ac5956c&prod&lang=css&"
import style1 from "./tagInput.vue?vue&type=style&index=1&id=2ac5956c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac5956c",
  null
  
)

export default component.exports